var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadingHistory
    ? _c("participants-co-broker-loader")
    : _c("v-client-table", {
        ref: "coBrokeringHistoryTable",
        staticClass: "vue-custom-table no-pagination",
        attrs: {
          data: _vm.CO_BROKERING_HISTORY,
          options: _vm.tableOptions,
          columns: _vm.tableOptions.columns,
        },
        scopedSlots: _vm._u([
          {
            key: "date",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("formatDate")(_vm.formatDate(row.cobrokeredAt))
                      ) +
                      "\n    "
                  ),
                ]),
              ]
            },
          },
          {
            key: "mortgageType",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", { staticClass: "text-capitalize" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.count." + row.mortgageType)) +
                      "\n    "
                  ),
                ]),
              ]
            },
          },
          {
            key: "mortgageAmount",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("formatMoneyValueLong")(row.totalLoanValue)
                      ) +
                      "\n    "
                  ),
                ]),
              ]
            },
          },
          {
            key: "submittedTo",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", [
                  _vm._v("\n      " + _vm._s(row.agentName) + "\n    "),
                ]),
              ]
            },
          },
          {
            key: "brokerage",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", [
                  _vm._v("\n      " + _vm._s(row.brokerageName) + "\n    "),
                ]),
              ]
            },
          },
          {
            key: "status",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("h6", { staticClass: "text-capitalize" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        row.status || _vm.$t("application.status.submitted")
                      ) +
                      "\n    "
                  ),
                ]),
              ]
            },
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }